export default "__VITE_ASSET__CqC0J85h__"